export const OVERLORD_BILLING_BYPASS_PATHS = ['/settings', '/users', '/couriers'] as const;

interface UserWithRoles {
  roles?: Array<{ name?: string }> | null;
}

export const isOverlord = (user: UserWithRoles | null | undefined): boolean => {
  const roleNames = user?.roles?.map((r) => r?.name) ?? [];
  return roleNames.includes('Overlord');
};

export const isBillingBypassPath = (pathname: string): boolean =>
  OVERLORD_BILLING_BYPASS_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`),
  );

export const canOverlordBypassBillingLock = (
  user: UserWithRoles | null | undefined,
  pathname: string,
): boolean => isOverlord(user) && isBillingBypassPath(pathname);

/**
 * A courier still in the setup wizard pays from its Subscribe step, so the
 * billing lock must not pull it off /onboarding — OnboardingRedirect sends it
 * straight back, and the two redirects ping-ponged forever.
 */
export const canFinishOnboardingDuringBillingLock = (
  courier: { onboardingStatus?: string | null } | null | undefined,
  pathname: string,
): boolean => pathname === '/onboarding' && courier?.onboardingStatus !== 'COMPLETED';
